import { createApp } from 'vue'
import { createPinia } from 'pinia'
import vant from "vant"
import { Icon } from 'vant';
import { Locale } from 'vant';
import roRO from 'vant/es/locale/lang/ro-RO';
import { register } from 'swiper/element/bundle';

import "./index.css"

import App from './App.vue'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(vant);
app.use(Icon);
Locale.use('ro-RO', roRO);

register();

app.mount('#app')
